import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLoneExplorersView from "./sections/TheLoneExplorersView";
import PulseMetricsFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheLoneExplorersView />
      <PulseMetricsFooter />
    </div>;
}